import React, { forwardRef } from 'react';
import _ from 'lodash';
import { SelectionListMultiSelect } from '../SelectionListMultiSelect';
import SelectionList from '../SelectionList';

/**
 * @typedef {object} OrgSelectorOwnProps
 * @property {Array<*>} organizations
 * @property {Array<*>} [value]
 * @property {(selectedIds: Array<number>) => void} onChange
 * @property {boolean} [isSingleOrgSelect]
 */

/**
 * @typedef {OrgSelectorOwnProps & React.ComponentPropsWithoutRef<typeof SelectionList>} OrgSelectorProps
 */

/**
 * @type {React.ForwardRefExoticComponent<OrgSelectorProps & React.RefAttributes<*>>}
 * @param {OrgSelectorProps} props
 */
export const OrgSelector = forwardRef((props, ref) => {
  const { organizations, value, onChange, isSingleOrgSelect, ...otherProps } = props;

  const options = _.chain(organizations)
    .map(getOrgOption)
    .sortBy(o => o.label.toLowerCase())
    .value();

  const handleSingleOrgSelection = selectedOrg => {
    onChange([selectedOrg.value]);
  };

  return isSingleOrgSelect ? (
    <SelectionList
      ref={ref}
      {...otherProps}
      id='select-org'
      placeholder='Select Organization'
      selectedValue={options.find(x => value.length && x.value === value[0])}
      onSelectHandler={handleSingleOrgSelection}
      list={options}
    />
  ) : (
    <SelectionListMultiSelect
      ref={ref}
      {...otherProps}
      id='select-org'
      placeholder='Select Organization(s)'
      options={options}
      value={value}
      onChange={onChange}
    />
  );
});

OrgSelector.displayName = 'OrgSelector';

const getOrgOption = org => ({
  label: org.Name,
  value: org.Id
});
